'use client'

import {createContext} from 'react'

export interface ProductGridContextProps {
	retreat: string
	setRetreat: (arg: string) => void
	isNotifyPanelOpen: boolean,
	setNotifyPanel: (arg:boolean) => void,
	isFilterPanelOpen: boolean,
	setFilterPanel: (arg:boolean) => void,
}

const ProductGridContext = createContext<ProductGridContextProps>({
	retreat: '',
	setRetreat: () => {},
	isNotifyPanelOpen: false,
	setNotifyPanel: () => {},
	isFilterPanelOpen: false,
	setFilterPanel: () => {},
})

export default ProductGridContext
